import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    position: "Facilities Manager",
    company: "McDonald\'s South Africa",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0007e95-1763295050768.png",
    imageAlt: "Professional woman with shoulder length brown hair wearing navy blue business blazer smiling confidently in corporate office setting",
    rating: 5,
    quote: "meriodine has been our trusted partner for over a decade. Their ability to handle complex kitchen installations while maintaining our operational standards is unmatched. The team's responsiveness during emergencies has saved us countless hours of downtime.",
    project: "Multi-location kitchen infrastructure",
    industry: "Restaurant"
  },
  {
    id: 2,
    name: "David Nkosi",
    position: "Operations Director",
    company: "KFC Regional Management",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d854688-1763295573707.png",
    imageAlt: "Professional African man with short black hair wearing charcoal gray suit and burgundy tie in modern office environment with natural lighting",
    rating: 5,
    quote: "Working with Gert and his team has transformed how we approach facility maintenance. Their preventive maintenance program has reduced our emergency calls by 60% and their project management skills are exceptional. Highly recommended for any commercial operation.",
    project: "Electrical system modernization",
    industry: "Restaurant"
  },
  {
    id: 3,
    name: "Jennifer van der Merwe",
    position: "Property Manager",
    company: "Gateway Shopping Center",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_150c1a00d-1767040171290.png",
    imageAlt: "Professional woman with blonde hair in elegant bun wearing cream colored blazer with pearl necklace in upscale retail environment",
    rating: 5,
    quote: "The professionalism and attention to detail displayed during our mall renovation was outstanding. They coordinated seamlessly with multiple stakeholders and completed the project ahead of schedule without disrupting our tenants. True professionals.",
    project: "Complete plumbing infrastructure upgrade",
    industry: "Retail"
  },
  {
    id: 4,
    name: "Michael Chen",
    position: "Facility Director",
    company: "Tech Park Johannesburg",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a94acfd5-1763299528067.png",
    imageAlt: "Professional Asian man with black hair wearing modern slim fit navy suit and patterned tie in contemporary corporate office with glass walls",
    rating: 5,
    quote: "Our LED retrofit project was completed flawlessly. The energy savings have exceeded projections and the improved lighting quality has received positive feedback from all our tenants. Their technical expertise and project coordination were exemplary.",
    project: "Office building electrical retrofit",
    industry: "Office"
  }];


  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-muted via-background to-muted">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
            <span className="text-primary font-semibold text-sm font-accent">Client Testimonials</span>
          </div>
          <h2 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            What Our Commercial Clients Say
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-3xl mx-auto font-body">
            Real feedback from facility managers and decision makers who trust meriodine for their critical infrastructure needs.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="bg-card rounded-2xl shadow-elevated p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              <div className="lg:col-span-1 text-center lg:text-left">
                <div className="relative inline-block mb-6">
                  <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-primary/20 mx-auto lg:mx-0">
                    <Image
                      src={testimonials?.[activeTestimonial]?.image}
                      alt={testimonials?.[activeTestimonial]?.imageAlt}
                      className="w-full h-full object-cover" />

                  </div>
                  <div className="absolute -bottom-2 -right-2 bg-primary text-primary-foreground w-12 h-12 rounded-full flex items-center justify-center shadow-lg">
                    <Icon name="Quote" size={24} />
                  </div>
                </div>

                <h3 className="font-headline font-bold text-xl md:text-2xl text-foreground mb-1">
                  {testimonials?.[activeTestimonial]?.name}
                </h3>
                <p className="text-primary font-semibold mb-1 font-body">
                  {testimonials?.[activeTestimonial]?.position}
                </p>
                <p className="text-muted-foreground text-sm mb-4 font-body">
                  {testimonials?.[activeTestimonial]?.company}
                </p>

                <div className="flex justify-center lg:justify-start gap-1 mb-4">
                  {[...Array(testimonials?.[activeTestimonial]?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-accent)" fill="var(--color-accent)" />
                  )}
                </div>

                <div className="inline-flex items-center gap-2 bg-muted px-3 py-1 rounded-full">
                  <Icon name="Briefcase" size={16} color="var(--color-primary)" />
                  <span className="text-sm text-foreground font-body">{testimonials?.[activeTestimonial]?.industry}</span>
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="mb-6">
                  <p className="text-foreground text-lg md:text-xl leading-relaxed font-body italic">
                    "{testimonials?.[activeTestimonial]?.quote}"
                  </p>
                </div>

                <div className="bg-muted rounded-lg p-4">
                  <p className="text-sm text-muted-foreground mb-1 font-body">Project:</p>
                  <p className="text-foreground font-semibold font-headline">
                    {testimonials?.[activeTestimonial]?.project}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 bg-card hover:bg-primary text-foreground hover:text-primary-foreground rounded-full flex items-center justify-center shadow-md transition-all"
              aria-label="Previous testimonial">

              <Icon name="ChevronLeft" size={24} />
            </button>

            <div className="flex gap-2">
              {testimonials?.map((_, index) =>
              <button
                key={index}
                onClick={() => setActiveTestimonial(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                index === activeTestimonial ? 'bg-primary w-8' : 'bg-muted'}`
                }
                aria-label={`Go to testimonial ${index + 1}`} />

              )}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 bg-card hover:bg-primary text-foreground hover:text-primary-foreground rounded-full flex items-center justify-center shadow-md transition-all"
              aria-label="Next testimonial">

              <Icon name="ChevronRight" size={24} />
            </button>
          </div>
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <p className="text-muted-foreground mb-6 font-body">
            Join our growing list of satisfied commercial clients
          </p>
          <a
            href="/client-success-stories"
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-semibold transition-colors font-body">

            <span>View More Success Stories</span>
            <Icon name="ArrowRight" size={20} />
          </a>
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;